// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"204348251077577b37b2","node_modules_dompurify_dist_purify_js":"19c004e4f495867231a5","node_modules_canvg_lib_index_es_js":"b2f5aa3fcec88f367d90"}[chunkId] + ".js";
};